"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const session_1 = require("../../session");
const authenticator_1 = require("../../authenticator");
const features_1 = require("../../features");
const store_1 = require("../../store");
const storage_1 = require("../../session/cc/storage");
const configureFramework = (bankId, language, additionalPlugins = []) => {
    const Session = new session_1.MbCCDevSession(new storage_1.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)()));
    //TODO Session needs XHR Authplugin and this plugin needs session
    const plugins = [...additionalPlugins, new features_1.XHRAcceptLanguagePlugin(language), new features_1.XHRBankIdPlugin(bankId)];
    Session.setXHR(new features_1.XHR({
        plugins,
    }));
    const AuthApi = new features_1.XHR({
        plugins: [...additionalPlugins],
    });
    const helper = new features_1.AssistedCCHelper(AuthApi);
    const Authenticator = new authenticator_1.MbCCDevAuthenticator(Session, AuthApi, helper);
    return {
        Session,
        Authenticator,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map